<template>
    <div>
        <el-container>
            <el-header height="15%">
                <div class="row">
                    <div class="col-md-3">
                        <h4>Пользователи</h4>
                    </div>
                    <div class="col-md-3">
                        <el-button @click="removeAll" type="danger">Удалить все (test 1C)</el-button>
                    </div>
                </div>

            </el-header>
            <el-main height="80%">
                <el-form aria-label="Поиск" >
                    <div class="row">
                        <div class="col-md-3">
                            <el-form-item label="Поиск по имени">
                                <el-col :span="14">
                                    <el-input v-model="query.filter.name" @change="getApplicationForms"></el-input>
                                </el-col>
                            </el-form-item>
                        </div>
                        <div class="col-md-3">
                            <el-form-item label="Поиск по телефону">
                                <el-col :span="14">
                                    <el-input v-model="query.filter.phone" @change="getApplicationForms"></el-input>
                                </el-col>
                            </el-form-item>
                        </div>
                        <div class="col-md-3">
                            <el-form-item label="Поиск по почте">
                                <el-col :span="14">
                                    <el-input v-model="query.filter.email" @change="getApplicationForms"></el-input>
                                </el-col>
                            </el-form-item>
                        </div>
                        <div class="col-md-3">
                            <el-form-item label="Сортировка">
                                <el-select v-model="query.sort" :width="300" @change="getApplicationForms">
                                    <el-option value="created_at.asc" label="Дата добавления по возрастанию"></el-option>
                                    <el-option value="created_at.desc" label="Дата добавления по убыванию"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </div>
                </el-form>

                <el-table :data="applicationForms" style="width: 100%">
                    <el-table-column
                            prop="id"
                            label="Id"
                            width="50"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="name"
                            label="Имя"
                    />
                    <el-table-column
                            prop="phone"
                            label="Телефон"
                    />
                    <el-table-column
                            label="Почта"
                            prop="email"
                    />
                    <el-table-column
                            label="Дата добавления"
                            prop="date"
                    />
                  <el-table-column
                      label="Тип цены"
                      prop="priceType"
                  />
                </el-table>
            </el-main>
            <el-footer height="5%">
                <el-pagination
                        background
                        layout="prev, pager, next"
                        :total="total"
                        :current-page.sync="current"
                        @current-change="getPage(current)"
                        :hide-on-single-page="true"
                        :page-size="paginator.meta.per_page"
                        :page-count="paginator.meta.last_page"
                >
                </el-pagination>
            </el-footer>
        </el-container>
    </div>
</template>

<script>
import axios from "axios";

export default {
    data: function (){
        return{
            status:0,
            applicationForms:[],
            paginator: [],
            current: 0,
            total:0,
            query:{
                filter:{
                    name:'',
                    phone:'',
                    email:''
                },
                sort:'created_at.desc'

            }
        }
    },
    mounted() {
        this.getApplicationForms();
    },
    methods:{
        getApplicationForms: function (){
            const qs = require('qs');
            axios.get('/api/admin/application-forms/index?'+qs.stringify(this.query)).then((response)=>
                {
                    this.applicationForms = response.data.data;
                    this.paginator = response.data;
                    this.current = response.data.meta.current_page;
                    this.total = response.data.meta.total;
                }
            ).catch((errors)=>{
                if(errors.response.status === 401){
                    this.$router.push('/login');
                }
            });
        },
        getPage: function(pageNum){
            const qs = require('qs');
            if(pageNum!==null){
                axios.get('/api/admin/application-forms/index?page='+pageNum+'&'+qs.stringify(this.query)).then((response) => {
                    this.paginator = response.data;
                    this.applicationForms = response.data.data;
                }).catch((errors)=>{
                    if(errors.response.status === 401){
                        this.$router.push('/login');
                    }
                });
            }
            this.success='';
            return this.paginator.first_page_url
        },
        removeAll(){
            axios.get('/api/admin/application-forms/delete').then(()=>
                {
                    this.getApplicationForms();
                }
            ).catch((errors)=>{
                if(errors.response.status === 401){
                    this.$router.push('/login');
                }
            });
        }
    }
}
</script>

<style scoped>

</style>